<template>
  <settings>
    <section class="devices-settings">
      <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
          <div class="card">
            <div class="card-body">
              <div class="page-header row flex-column-reverse flex-md-row">
                <div class="col-lg-2">
                  <b-form-group class="mb-0" size="sm">
                    <b-form-radio-group
                      v-model="selectedShowType"
                      :options="showTypes"
                      buttons
                      class="align-items-center justify-content-center show-type"
                      size="sm"
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
                <div class="col-lg-4 mb-0">
                  <b-form-group class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input
                        :value="search"
                        :placeholder="$t('userTable.search.placeholder')"
                        @change.native="search = $event.target.value"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          class="cleat-btn"
                          :disabled="!search"
                          style="padding: 0rem 0.81rem"
                          @click="search = ''"
                        >
                          {{ $t('button.clear.label') }}
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="col-lg-2 mb-0">
                  <new-request-modal-common
                    modal-id="callme-request-modal"
                  ></new-request-modal-common>
                  <b-btn
                    v-b-modal="'callme-request-modal'"
                    variant="info"
                    class="btn-icon-text ml-1 w-100"
                  >
                    {{ $t('button.callMe.label') }}
                  </b-btn>
                </div>
              </div>
              <div class="row overflow-auto">
                <div class="col-12">
                  <b-table
                    v-if="items"
                    id="boxe-list"
                    show-empty
                    small
                    stacked="md"
                    :items="items"
                    responsive
                    :per-page="perPage"
                    :fields="fields"
                    :sort-by.sync="sortBy"
                    :busy="loading"
                    :sort-desc.sync="sortDesc"
                  >
                    <template #table-busy>
                      <loader></loader>
                    </template>
                    <template #cell(status)="row">
                      <label class="badge" :class="[getColorClassForStatus(row.item.status)]">
                        {{ $t('workRequestStatus.' + row.item.status) }}
                      </label>
                    </template>
                  </b-table>
                </div>
              </div>
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                hide-goto-end-buttons
                class="rounded"
                aria-controls="boxe-list"
                align="right"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    </section>
  </settings>
</template>

<script>
import requestsQuery from '@/api/support/requests.gql';

export default {
  name: 'SupportRequests',
  data: function () {
    return {
      inviteLoadin: false,
      sortBy: 'id',
      perPage: 12,
      currentPage: 1,
      sortDesc: false,
      sortByFormatted: false,
      selectedShowType: 'ACTIVE',
      showTypes: [
        {
          text: this.$t('tableRequests.types.all'),
          value: 'ALL',
        },
        {
          text: this.$t('tableRequests.types.active'),
          value: 'ACTIVE',
        },
        {
          text: this.$t('tableRequests.types.archive'),
          value: 'ARCHIVE',
        },
      ],
      search: null,
      fields: [
        {
          key: 'id',
          label: this.$t('tableRequests.columns.id'),
          sortable: true,
          class: 'text-center',
        },
        {
          key: 'content',
          label: this.$t('tableRequests.columns.content'),
          sortable: false,
        },
        {
          key: 'status',
          label: this.$t('tableRequests.columns.status'),
          sortable: true,
        },
      ],
    };
  },
  apollo: {
    workRequestConnection: {
      query() {
        return requestsQuery;
      },
      variables() {
        return {
          // skip: this.itemsAfter,
          // take: this.perPage,
          // search: this.search,
          // where: this.where,
          // orderBy: this.orderBy,
        };
      },
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.workRequest && queryData.workRequest.length) {
          let edges = queryData.workRequest;
          return {
            edges,
            totalCount: 0,
          };
        } else {
          return null;
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  computed: {
    orderBy() {
      if (!this.sortBy) {
        return [];
      }
      return [{ path: this.sortBy, descending: this.sortDesc }];
    },
    where() {
      let wheres = [
        {
          path: 'workRequestDirectionId',
          comparison: 'in',
          value: ['SUP', 'SAL'],
        },
      ];
      let typeExp = this.createShowTypeWhereExpression();
      if (typeExp) {
        wheres.push(typeExp);
      }

      return wheres;
    },
    loading() {
      return this.$apollo.queries.workRequestConnection.loading;
    },
    items() {
      let request = this.workRequestConnection || {};
      return request.edges || [];
    },
    totalRows() {
      let request = this.workRequestConnection || {};
      return request.totalCount || 1;
    },
    itemsAfter() {
      return this.currentPage && this.currentPage > 1
        ? (this.currentPage - 1) * this.perPage - 1
        : null;
    },
  },
  watch: {
    currentPage: function () {
      this.$apollo.queries.workRequestConnection.refresh();
    },
    selectedShowType: function () {
      this.$apollo.queries.workRequestConnection.refresh();
    },
    search: function () {
      this.currentPage = 1;
    },
  },
  methods: {
    addedRequest() {
      this.$apollo.queries.workRequestConnection.refresh();
    },
    createShowTypeWhereExpression() {
      this.currentPage = 1;
      if (this.selectedShowType == 'ARCHIVE') {
        return {
          path: 'status',
          comparison: 'equal',
          value: 'ARCHIVE',
        };
      }

      if (this.selectedShowType == 'ALL') {
        return null;
      }

      if (this.selectedShowType == 'ACTIVE') {
        return {
          path: 'status',
          comparison: 'notEqual',
          value: 'ARCHIVE',
        };
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getColorClassForStatus(status) {
      switch (status) {
        case 'ARCHIVE':
          return 'badge-secondary';
        case 'CANCELED':
          return 'badge-danger';
        case 'EXECUTION':
        case 'PREPARATION':
        case 'RESPONSIBLE':
        case 'DISPATCHER':
        case 'CREATION':
          return 'badge-success';
        default:
          return 'badge-warning';
      }
    },
  },
};
</script>

<style>
.show-type label {
  color: #ffffff;
  background-color: #343a40;
  border-color: #343a40;
}
.show-type label:hover {
  background: #0090e7 !important;
  border-color: #0090e7 !important;
  color: #ffffff;
}

.show-type .active {
  background: #0090e7 !important;
  border-color: #0090e7 !important;
  color: #ffffff;
}
</style>
